import React from "react";

import { Chart } from "../../Chart";

const LineChart = (options) => {
  return <Chart options={{ ...options }} />;
};

export default LineChart;
